import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { environment } from 'environments/environment';
import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LogHelper } from '../helpers/log.helper';

@Injectable({
  providedIn: 'root'
})
export class MfaService {

  constructor(private msalService: MsalService) {}

  authenticateWithMfa(): Observable<boolean> {
    const account = this.msalService.instance.getActiveAccount();
    
    if (!account) {
      LogHelper.error('MFA Authentication', 'No active account found');
      return of(false);
    }

    return from(
      this.msalService.instance.acquireTokenPopup({
        scopes: [environment.msalConfig.scope],
        account: account,
        prompt: 'login'
      })
    ).pipe(
      map((response: AuthenticationResult) => {
        LogHelper.log('MFA Authentication successful');
        return true;
      }),
      catchError(error => {
        LogHelper.error('MFA Authentication failed', error);
        return of(false);
      })
    );
  }
}
